/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              projectName.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */

var novicell = novicell || {};
var phoenixTag = phoenixTag || {};

// Document ready
(function ($) {
  // Only include Novicell functions that you use!
  novicell.map.init();
  novicell.cookieInfo.init();
  novicell.embed.loadEmbeds();
  novicell.responsiveLazyloadImage.onLoad();

  phoenixTag.header.mobileNav();

  phoenixTag.packery.constructFilter();
  phoenixTag.packery.initPackery();

  phoenixTag.utilities.setBackground(".reference-list__figure");
  phoenixTag.utilities.departmentOverlay(".department-switcher-button");
  phoenixTag.utilities.departmentOverlay(".department-info__container button");
  phoenixTag.utilities.mediaOverlay(".media-trigger");
  phoenixTag.utilities.productList();

  // Call new functions here like this:
  //projectName.slider.heroSlider($('.owl-carousel'));
  svg4everybody(); // Fix SVG spritemap in IE/Edge

  $(window).on('load', function () {
    //$(window).trigger('resize');
    phoenixTag.packery.initPackery();
  });

  $(window).smartresize(function () {
    novicell.responsiveLazyloadImage.onResize();
    novicell.embed.onResize();
  });

  $(window).smartscroll(function () {
    if ($('.responsiveLazyload').length) {
      novicell.responsiveLazyloadImage.onScroll();
    }
    if ($('.embed-media-item').length) {
      novicell.embed.loadEmbeds();
    }
  });

})(jQuery);